import { createApp } from 'vue';

import App from './App.vue';
import router from './router';
import { store } from './store';
import { registerSW } from 'virtual:pwa-register';

import { library } from '@fortawesome/fontawesome-svg-core';

import { faWindows } from '@fortawesome/free-brands-svg-icons';

import {
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faArrowDownLong,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faArrowRotateLeft,
  faArrowRotateRight,
  faArrowUpLong,
  faBan,
  faBars,
  faBold,
  faBoxOpen,
  faBoxesStacked,
  faCertificate,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleInfo,
  faClone,
  faEnvelope,
  faFileContract,
  faFileDownload,
  faFileLines,
  faFilePdf,
  faFloppyDisk,
  faGear,
  faIndent,
  faItalic,
  faLayerGroup,
  faList,
  faListCheck,
  faListOl,
  faListUl,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faMinus,
  faOutdent,
  faPaperPlane,
  faPen,
  faPenRuler,
  faPenToSquare,
  faPlus,
  faPrint,
  faRotate,
  faStrikethrough,
  faSubscript,
  faSuperscript,
  faTable,
  faTableColumns,
  faTextSlash,
  faTrash,
  faUnderline,
  faUsers,
  faUsersViewfinder,
  faWarehouse,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faAlignLeft,
  faAlignRight,
  faAlignCenter,
  faAlignJustify,
  faArrowDownLong,
  faArrowRotateLeft,
  faArrowRotateRight,
  faArrowUpLong,

  faArrowRightFromBracket,
  faArrowRightToBracket,

  faBan,
  faBars,
  faBold,
  faBoxOpen,
  faBoxesStacked,

  faCertificate,
  faCheck,
  faCircleCheck,
  faCircleInfo,

  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,

  faClone,

  faEnvelope,
  faFileContract,
  faFileDownload,
  faFileLines,
  faFilePdf,
  faFloppyDisk,

  faGear,

  faIndent,
  faItalic,

  faLayerGroup,
  faList,
  faListCheck,
  faListOl,
  faListUl,

  faMagnifyingGlass,
  faMagnifyingGlassPlus,

  faMinus,

  faOutdent,

  faPaperPlane,
  faPen,
  faPenRuler,
  faPenToSquare,
  faPlus,
  faPrint,

  faRotate,

  faStrikethrough,
  faSubscript,
  faSuperscript,

  faTable,
  faTableColumns,
  faTextSlash,
  faTrash,

  faUnderline,
  faUsers,

  faUsersViewfinder,
  faWarehouse,
  faXmark,
  faWindows
);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

registerSW({ immediate: true });

const app = createApp(App);

app.use(store);
app.use(router);
app.component('font-awesome-icon', FontAwesomeIcon);
app.mount('#app');

import 'bootstrap';
